import axiosClient from "@/libs/axiosClient";

export const getFormOptions = (endpoint) => {
    return axiosClient.get(`/formoptions/${endpoint}`);
};



// WEBPACK FOOTER //
// ./src/api/formoptions.js